module.exports = __webpack_public_path__ + "img/icon_heart_1.3c8774fc.svg";